import { QuestionCircleOutlined } from '@easyv/react-icons';
import * as React from 'react';
import { Tooltip } from '@easyv/react-components';
import classNames from 'classnames';

interface ImmerFormItemProps {
  label?: string;
  children?: React.ReactNode;
  tooltip?: React.ReactNode;
  labelVerticalAlign?: 'top' | 'middle';
  /**
   * large: 36px, default: 32px, small: 28px, mini: 24px
   */
  size?: 'large' | 'default' | 'small' | 'mini';
  nodeAfter?: React.ReactNode;
  disabled?: boolean;
}

export function ImmerFormItem(props: ImmerFormItemProps) {
  const {
    label,
    children,
    tooltip,
    size = 'large',
    labelVerticalAlign = 'middle',
    nodeAfter,
    disabled: disable,
  } = props;

  return (
    <div
      className={classNames(
        'flex immer-form-item',
        labelVerticalAlign === 'top' ? 'items-start' : 'items-center',
      )}
    >
      <div
        className={classNames(
          'flex-1 overflow-ellipsis flex items-center justify-between immer-form-item-label leading-5',
          size === 'large' ? 'h-9' : size === 'small' ? 'h-7' : size === 'mini' ? 'h-6' : 'h-8',
        )}
      >
        <div
          className={classNames('flex items-center overflow-hidden', disable && 'text-content4')}
        >
          <div className='truncate' title={label}>
            {label}
          </div>
          {tooltip && (
            <Tooltip content={tooltip}>
              <QuestionCircleOutlined className='ml-1 text-content3' size={12} />
            </Tooltip>
          )}
        </div>
        {nodeAfter}
      </div>

      <div className='w-formContent pl-2'>{children}</div>
    </div>
  );
}
